export default "__VITE_ASSET__D97ddxCe__"